export enum DashboardContasPagar  {
  id = 'ed850d0b-915f-4ced-a70a-ea8d7a70224a',
  idSec = 'ec717df08b18a3853427',
}
